import { Modal } from "react-bootstrap";
import styles from "./StopLossLogsModal.module.css";
import React, { useState, useEffect } from "react";
import { Stack } from "react-bootstrap";
import TableRb from "../../../../components/Tables/tableRb";
import arrowUpIcon from "../../../../assets/icons/arrow_up_icon.svg";
import arrowDownIcon from "../../../../assets/icons/down_arrow.svg";
import axios from "axios";
import { useGlobalContext } from "../../../../context/global";
import FilterPreview from "./../../subComponents/FilterViewer/FilterViewer";
import moment from "moment";
import { getProductWithImageForLogs } from "../../../../components/Reports/Components/utils";
import { generateShimmerTable } from "../../../../helper/common/tableShimmerGenerator";
import Spinner from "../../../../components/spinners/spinner";
import { getCubeFiltersByActionTypeForCamelCase } from "../../../../helper/Quadrant/quadrantHelper";
import { toast } from "react-toastify";
import { PRODUCT_SET_LOGS_DATAHEADS, STOP_LOSS_LOGS_DATAHEADS } from "../../../../constant/productset/productsetconfig";
import { getStopLossLogsChildConfig } from "../../../../constant/stopLoss/stopLossLogsChildConfig";
import CustomPagination from "../../../../components/CustomPagination/CustomPagination";
import {
  formatChildMetricValue,
  getConfiguredFilterMembers,
  getMetricValueFromProductStats,
  getPlatformFieldMap,
  getValueFromProductStats,
  resolveFieldConfig,
} from "../../../../helper/StopLoss/stopLossChildMetricsPreview";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ModalRb from "../../../../components/modal/ModalRb";

const CHILD_LOGS_DEFAULT_LIMIT = 20;

const StopLossLogsList = ({ logId = "",pageName }) => {
  const { clientId } = useGlobalContext();

  const [allFetchLoaders, setAllFetchLoaders] = useState({
    mainPageLoader: false,
  });
  const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
  const [childData, setChildData] = useState({});
  const [childPagination, setChildPagination] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const [isChildDataLoading, setIsChildDataLoading] = useState([]);
  const isStopLossPage = pageName === 'stoploss';
  const isProductSetPage = pageName === 'productset';
  const isAmazonPlatform = userPlatform === "amazon";
  const excludedImpactLabel = isAmazonPlatform ? "Paused" : "Excluded";
  const initialDataHeads = isStopLossPage ? STOP_LOSS_LOGS_DATAHEADS : isProductSetPage ? PRODUCT_SET_LOGS_DATAHEADS : []
  const [dataHeads, setdataHeads] = useState(
  initialDataHeads
  );

  const [logsList, setLogsList] = useState([]);
  const [entityListModal, setEntityListModal] = useState({
    show: false,
    title: "",
    items: [],
  });
  const PRODUCT_SET_DATE_OPTIONS = [
    { value: "last_7d", label: "Last 7 days", type: "" },
    { value: "last_14d", label: "Last 14 days", type: "" },
    { value: "last_30d", label: "Last 30 days", type: "" },
  ];
  const logsType = isStopLossPage ? 'Automation' : 'PRODUCT_SET'
  const logsRuleType = isStopLossPage ? 'rule_tracking' : 'PRODUCT_SET_TRACKING'
  async function fetchLogsList(logId) {
    if (!logId) return;
    let tempFiltering = isStopLossPage ?  [
      { field_name: "rule_name", operator: "IN", values: [logId] },
      { field_name: "flag_is_scheduled", operator: "NOT_EQUALS", value: null },
      { field_name: "flag_is_scheduled", operator: "EQUALS", value: 1 },
      { field_name: "change_recommended", operator: "NOT_EQUALS", value: null },
    ] : [{field_name:'product_set_id',operator:"IN",values:[logId]}]
    let encodedFiltering = encodeURIComponent(JSON.stringify(tempFiltering));
    let url = `${process.env.REACT_APP_ADS_API}/client/${clientId}/logs?source=${userPlatform}&type=${logsType}&filtering=${encodedFiltering}&rule_type=${logsRuleType}`;
    setAllFetchLoaders({ ...allFetchLoaders, mainPageLoader: true });
    await axios
      .get(url)
      .then((logsList) => {
        let formattedLogsList = logsList?.data.map((log) => {
          const parsedLog = isStopLossPage ? {
            ...log,
            rule_config: JSON.parse(log.rule_config),
            decision: JSON.parse(log.decision),
          } : {
            ...log,
            product_set_config : JSON.parse(log?.product_set_config ?? '{}'),
            decision:JSON.parse(log?.decision ?? '{}')
          }
          return parsedLog
        });
        setLogsList(formattedLogsList);
      })
      .catch((error) => {
        console.error("Error fetching logs list:", error);
        toast.error("Error fetching logs list", {
          toastId: "error-fetching-logs-list",
        });
      })
      .finally(() => {
        setAllFetchLoaders({ ...allFetchLoaders, mainPageLoader: false });
      });
  }

  const getNestedValue = (obj, path) => {
    return path.split("?.").reduce((acc, key) => acc?.[key], obj);
  };

  const renderOnlyRecommendation = (decision) => {
    if (decision?.decisionApplied === false) return "Yes";
    if (decision?.decisionApplied === true) return "No";
    return "-";
  };

  const renderParentImpactType = (decision) => {
    const countIncluded = decision?.extraInfo?.count_included;
    const countExcluded = decision?.extraInfo?.count_excluded;
    const countRetained = decision?.extraInfo?.count_retained;
    if (
      countIncluded == null &&
      countExcluded == null &&
      countRetained == null
    ) {
      return "-";
    }
    const totalLive =
      (Number(countRetained) || 0) + (Number(countIncluded) || 0);
    return (
      <div className={styles.impactTypeStack}>
        <div>Included: {countIncluded ?? 0}</div>
        <div>
          {excludedImpactLabel}: {countExcluded ?? 0}
        </div>
        <div>Total (Live): {totalLive}</div>
      </div>
    );
  };

  const renderChildImpactType = (impactType) => {
    if (impactType === "INCLUDED" || impactType === "INCLUDE") {
      return <span className={styles.blueBadge}>Included</span>;
    }
    if (impactType === "EXCLUDED" || impactType === "EXCLUDE") {
      return <span className={styles.grayBadge}>{excludedImpactLabel}</span>;
    }
    if (impactType === "RETAINED") {
      return <span className={styles.purpleBadge}>Live</span>;
    }
    return "-";
  };

  const getProductSetHeaderTooltip = (column) => {
    if (column?.id === "impact_type") {
      const excludedTooltipText = isAmazonPlatform
        ? `${excludedImpactLabel} — Paused in this run.`
        : `${excludedImpactLabel} — Removed in this run.`;
      return (
        <div className={styles.headerTooltipContent}>
          <div>Included — Added in this run.</div>
          <div>{excludedTooltipText}</div>
          <div>Total (Live) — Currently live under this rule.</div>
        </div>
      );
    }
    return column?.tooltip || "";
  };

  const renderHeaderLabel = (column) => {
    const label = (
      <span
        className="captital-first-letter"
        style={{ whiteSpace: "nowrap" }}
      >
        {column.fieldName.toLowerCase()}
      </span>
    );

    if (!isProductSetPage) return label;

    const tooltipTitle = getProductSetHeaderTooltip(column);
    if (!tooltipTitle) return label;

    return (
      <span className={styles.headerWithTooltip}>
        {label}
        <Tooltip title={tooltipTitle} arrow placement="top">
          <InfoOutlinedIcon className={styles.headerInfoIcon} fontSize="inherit" />
        </Tooltip>
      </span>
    );
  };

  const stopLossChildColumnConfig = getStopLossLogsChildConfig(userPlatform);

  const getChildProductStats = (childRow) =>
    getNestedValue(childRow, stopLossChildColumnConfig.impact.statsDataPath) ?? {};
  
  const renderChildImpact = (childRow) => {
    
    if (!isStopLossPage) {
      const productNameWithImage =
        childRow?.extra_info_json?.extraInfo?.productNameWithImage;
      return (
        getProductWithImageForLogs(productNameWithImage, childRow?.entity_id) ??
        "-"
      );
    }

    const { impact } = stopLossChildColumnConfig;
    const productStats = getChildProductStats(childRow);
    const productName = getValueFromProductStats(
      productStats,
      impact.productNameKey
    );
    const entityId =
      getValueFromProductStats(
        productStats,
        impact.entityIdKey,
        ...(impact.entityIdFallbackKeys ?? [])
      ) ??
      childRow?.entity_id ??
      null;
    if (impact.showImage) {
      return getProductWithImageForLogs(productName, entityId) ?? "-";
    }

    return (
      <div className="d-flex flex-column">
        {entityId ? <div style={{fontWeight:600}}>{entityId}</div> : null}
        <div>{productName ?? "-"}</div>
      </div>
    );
  };

  const getChildAdSpendSaved = (childRow) => {
    if (!isStopLossPage) {
      return null;
    }
    const { ad_spend_saved: adSpendConfig } = stopLossChildColumnConfig;
    const productStats =
      getNestedValue(childRow, adSpendConfig.statsDataPath) ?? {};
    return getValueFromProductStats(productStats, adSpendConfig.metricKey);
  };

  const platformFieldMap = getPlatformFieldMap(userPlatform);

  const renderChildConfiguredMetrics = (childRow, filters) => {
    const configuredMembers = getConfiguredFilterMembers(filters);
    if (!configuredMembers.length) {
      return <span>-</span>;
    }

    const productStats = getChildProductStats(childRow);

    return (
      <div className={styles.childMetricsPreview}>
        {configuredMembers.map((member) => {
          const fieldConfig = resolveFieldConfig(platformFieldMap, member);
          const label = fieldConfig?.name ?? member?.split(".")?.pop() ?? member;
          const value = fieldConfig
            ? getMetricValueFromProductStats(
                productStats,
                fieldConfig,
                userPlatform
              )
            : getValueFromProductStats(productStats, member);

          return (
            <p key={member} className={styles.childMetricRow}>
              {label} {formatChildMetricValue(value)}
            </p>
          );
        })}
      </div>
    );
  };

  const getChildCaseFilters = (parentRowData, actionType) => {
    const cubeFilters = getCubeFiltersByActionTypeForCamelCase(
      parentRowData?.rule_config?.ruleTasks,
      actionType
    );
    if (!cubeFilters) return null;
    try {
      return JSON.parse(cubeFilters)?.query?.filters ?? null;
    } catch {
      return null;
    }
  };

  const getDatePresetLabel = (datePreset) => {
    const dateOption = PRODUCT_SET_DATE_OPTIONS.find(
      (option) => option.value === datePreset
    );
    return dateOption ? dateOption.label : "Custom Date";
  };

  const getChildUniqueKey = (track_id, effective_change, rule_name) =>
    isStopLossPage ? track_id + effective_change + rule_name : track_id;

  const getParentProductCount = (rowData) => {
    if (isProductSetPage) {
      const extraInfo = rowData?.decision?.extraInfo ?? {};
      const countIncluded = extraInfo?.count_included;
      const countExcluded = extraInfo?.count_excluded;
      const countRetained = extraInfo?.count_retained;
      if (
        countIncluded != null ||
        countExcluded != null ||
        countRetained != null
      ) {
        return (
          (Number(countIncluded) || 0) +
          (Number(countExcluded) || 0) +
          (Number(countRetained) || 0)
        );
      }
    }
    return Number(rowData?.decision?.extraInfo?.product_count) || 0;
  };

  const getChildTotalPages = (productCount, limit = CHILD_LOGS_DEFAULT_LIMIT) =>
    productCount > 0 ? Math.ceil(productCount / limit) : 0;

  const parseChildLogRows = (response) => {
    const payload = response?.data;
    const rows = Array.isArray(payload) ? payload : payload?.data ?? [];
    return rows;
  };

  const formatChildLogRow = (log) => {
    if (isStopLossPage) {
      return {
        ...log,
        rule_config: JSON.parse(log?.rule_config ?? "{}"),
        metrices: JSON.parse(log?.metrices ?? "{}"),
      };
    }
    return {
      ...log,
      extra_info_json: JSON.parse(log?.extra_info_json ?? "{}"),
    };
  };

  const fetchChildData = async (
    track_id,
    effective_change,
    rule_name,
    page = 0,
    limit = CHILD_LOGS_DEFAULT_LIMIT,
    parentProductCount = 0
  ) => {
    const UNIQUE_KEY = getChildUniqueKey(track_id, effective_change, rule_name);
    let tempFiltering = isStopLossPage
      ? [
          { field_name: "track_id", operator: "EQUALS", value: track_id },
          { field_name: "message", operator: "EQUALS", value: effective_change },
          { field_name: "rule_name", operator: "EQUALS", value: rule_name },
        ]
      : [{ field_name: "track_id", operator: "IN", values: [track_id] }];
    const trackingType = isStopLossPage
      ? "rule_entity_tracking"
      : "PRODUCT_SET_ENTITY_TRACKING";
    let encodedFiltering = encodeURIComponent(JSON.stringify(tempFiltering));
    setIsChildDataLoading((prev) =>
      prev.includes(UNIQUE_KEY) ? prev : [...prev, UNIQUE_KEY]
    );
    setChildData((prev) => ({ ...prev, [UNIQUE_KEY]: [] }));
    setChildPagination((prev) => ({
      ...prev,
      [UNIQUE_KEY]: {
        ...prev[UNIQUE_KEY],
        currentPage: page,
        limit,
        totalItems: parentProductCount,
        totalPages: getChildTotalPages(parentProductCount, limit),
      },
    }));
    let childUrl = `${process.env.REACT_APP_ADS_API}/client/${clientId}/logs?source=${userPlatform}&type=${logsType}&filtering=${encodedFiltering}&rule_type=${trackingType}&limit=${limit}&page=${page}`;
    await axios
      .get(childUrl)
      .then((response) => {
        const rows = parseChildLogRows(response);
        const formattedRows = rows.map(formatChildLogRow);
        const totalPages = getChildTotalPages(parentProductCount, limit);

        setChildData((prev) => ({
          ...prev,
          [UNIQUE_KEY]: formattedRows,
        }));
        setChildPagination((prev) => ({
          ...prev,
          [UNIQUE_KEY]: {
            currentPage: page,
            limit,
            totalItems: parentProductCount,
            totalPages,
          },
        }));
      })
      .catch((error) => {
        console.error("Error fetching child data:", error);
        toast.error("Error fetching child data", {
          toastId: "error-fetching-child-data",
        });
      })
      .finally(() => {
        setIsChildDataLoading((prev) => prev.filter((id) => id !== UNIQUE_KEY));
      });
  };

  const handleChildPageChange = async (
    uniqueKey,
    trackId,
    effectiveChange,
    ruleName,
    pageNumber,
    parentProductCount
  ) => {
    const pagination = childPagination[uniqueKey];
    const limit = pagination?.limit ?? CHILD_LOGS_DEFAULT_LIMIT;
    await fetchChildData(
      trackId,
      effectiveChange,
      ruleName,
      pageNumber,
      limit,
      parentProductCount
    );
  };

  const toggleRow = async (
    trackId,
    effective_change,
    rule_name,
    parentProductCount = 0
  ) => {
    const UNIQUE_KEY = getChildUniqueKey(trackId, effective_change, rule_name);
    const isCurrentlyExpanded = expandedRows[UNIQUE_KEY];

    if (isCurrentlyExpanded) {
      setExpandedRows((prev) => ({ ...prev, [UNIQUE_KEY]: false }));
      setChildData((prev) => {
        const next = { ...prev };
        delete next[UNIQUE_KEY];
        return next;
      });
      setChildPagination((prev) => {
        const next = { ...prev };
        delete next[UNIQUE_KEY];
        return next;
      });
      return;
    }

    setExpandedRows((prev) => ({ ...prev, [UNIQUE_KEY]: true }));
    await fetchChildData(
      trackId,
      effective_change,
      rule_name,
      0,
      CHILD_LOGS_DEFAULT_LIMIT,
      parentProductCount
    );
  };

  useEffect(() => {
    fetchLogsList(logId);
  }, [logId]);

  const openEntityListModal = (title, items = []) => {
    setEntityListModal({
      show: true,
      title,
      items,
    });
  };

  const closeEntityListModal = () => {
    setEntityListModal({
      show: false,
      title: "",
      items: [],
    });
  };

  const renderEntityListTable = (items, columnLabel) => (
    <div className="main-campaignlist-table-body-container automations-main-table-wrappe automation-filter-table-body">
      {items?.length ? (
        <table className="automations-list-table">
          <thead className="fixed-table">
            <tr>
              <th style={{ position: "sticky", top: 0 }}>{columnLabel}</th>
            </tr>
          </thead>
          <tbody className="another-body">
            {items.map((name, index) => (
              <tr key={`${name}-${index}`}>
                <td>{name || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
    </div>
  );

  const entityListModalBody = (
    <div className="d-flex gap-5">
      {entityListModal.items?.length ? (
        <div className="automations-table-wrapper">
          <small className="text-center">
            {`Total ${entityListModal.title}: ${entityListModal.items.length}`}
          </small>
          <div className="automations-main-table">
            <TableRb
              table={renderEntityListTable(
                entityListModal.items,
                entityListModal.title === "Adgroups"
                  ? "Adgroup Name"
                  : "Campaign Name"
              )}
            />
          </div>
        </div>
      ) : (
        <h2>No Data To Show</h2>
      )}
    </div>
  );

  const renderAdgroupsOrCampaigns = (data, key) => {
    const mappedData = (data ?? [])
      .map((childData) => childData?.[key] ?? "")
      .filter((name) => name !== "");
    const firstData = mappedData[0] ?? "-";
    const remainingCount = Math.max(mappedData.length - 1, 0);
    const modalTitle = key === "adset_name" ? "Adgroups" : "Campaigns";

    return (
      <div style={{ display: "inline-block", position: "relative" }}>
        <span>{firstData}</span>
        {remainingCount > 0 && (
          <span
            className={styles.purpleBadge}
            title={`Click to see all ${modalTitle.toLowerCase()}`}
            style={{ marginLeft: "4px", cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              openEntityListModal(modalTitle, mappedData);
            }}
          >
            +{remainingCount}
          </span>
        )}
      </div>
    );
  };
  

  let tableBody = (
    <div className="defaultTableContainer lsit-table-scrollbar">
      {logsList?.length ? (
        <table>
          <thead className="fixed-table">
            <tr className="main-table-row-fixed">
              {dataHeads?.map((th, mainIndex) => {
                return (
                  <th
                    style={{ minWidth: th?.minWidth ? th?.minWidth : "auto" }}
                    className={styles.logsTableHead}
                    key={th?.id || mainIndex}
                  >
                    {renderHeaderLabel(th)}
                  </th>
                );
              })}
            </tr>
          </thead>
          {logsList?.length ? (
            <tbody className="another-tbody">
              {logsList?.map((rowData, index) => {
                const UNIQUE_KEY = isStopLossPage ? rowData?.track_id + rowData?.effective_change + rowData?.rule_name : rowData?.track_id
                const isExpanded =
                  expandedRows[UNIQUE_KEY]; // Check if row is expanded
                const children = childData[UNIQUE_KEY] || [];
                const childPageMeta = childPagination[UNIQUE_KEY] ?? {
                  currentPage: 0,
                  limit: CHILD_LOGS_DEFAULT_LIMIT,
                };
                const parentProductCount = getParentProductCount(rowData);
                const totalChildPages = getChildTotalPages(
                  parentProductCount,
                  childPageMeta.limit
                );
                const productSetConfig = rowData?.product_set_config ?? {};
                const cubeFilters = isStopLossPage
                  ? {}
                  : JSON.parse(productSetConfig?.cubeFilters ?? "{}");
                const entity_list =
                  JSON.parse(rowData?.extra_info_json ?? "{}")
                    ?.populated_entity_list ?? [];
                const campaigns = renderAdgroupsOrCampaigns(
                  entity_list,
                  "campaign_name"
                );
                const adgroups = renderAdgroupsOrCampaigns(
                  entity_list,
                  "adset_name"
                );

                return (
                  <React.Fragment
                    key={UNIQUE_KEY}
                  >
                    <tr>
                      {dataHeads?.map((column, index1) => {
                        let cellContent;
                        switch (column?.id) {
                          case "impact":
                            cellContent = (
                              <td
                                onClick={() =>
                                {
                                  if(parentProductCount == 0) return;
                                  toggleRow(
                                    rowData?.track_id,
                                    rowData?.effective_change,
                                    rowData?.rule_name,
                                    parentProductCount
                                  )
                                }
                                }
                                key={index1 + 1}
                                className="td-with-loader"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "6px",
                                    minWidth: "max-content",
                                  }}
                                >
                                  {parentProductCount || "0"}{" "}
                                  Products
                                  {(parentProductCount != 0) && <img
                                    src={
                                      isExpanded ? arrowUpIcon : arrowDownIcon
                                    }
                                    alt="arrow"
                                  />}
                                </div>
                              </td>
                            );
                            break;
                          case "campaign_name":
                            cellContent = (
                              <td className="text-nowrap">
                                {
                                  campaigns ?? '-'
                                }
                              </td>
                            )
                            break;
                            case "adset_name":
                              cellContent = (
                                <td className="text-nowrap">
                                  {
                                    adgroups ?? '-'
                                  }
                                </td>
                              )
                              break;
                          case "ad_spend_saved":
                            cellContent = (
                              <td className="text-nowrap">
                                {rowData?.decision?.extraInfo?.adSpendSaved
                                  ? "₹" +
                                    getNestedValue(
                                      rowData,
                                      column?.apiKey
                                    )?.toFixed(2)
                                  : "-"}
                              </td>
                            );
                            break;
                          case "only_recommendation":
                            cellContent = (
                              <td className="text-nowrap">
                                {renderOnlyRecommendation(rowData?.decision)}
                              </td>
                            );
                            break;
                          case "effective_status":
                            cellContent = (
                              <td className="text-nowrap">
                                {rowData?.effective_change ? (
                                  rowData?.effective_change ===
                                  "PRODUCT_ENABLED" ? (
                                    <span className={styles.blueBadge}>
                                      Included
                                    </span>
                                  ) : rowData?.effective_change ===
                                    "PRODUCT_PAUSED" ? (
                                    <span className={styles.grayBadge}>
                                      Excluded
                                    </span>
                                  ) : (
                                    rowData?.effective_change
                                      ?.split("_")
                                      ?.join(" ")
                                  )
                                ) : (
                                  "-"
                                )}
                              </td>
                            );
                            break;
                          case "activity_time":
                            cellContent = (
                              <td key={index1 + 1} className="td-with-loader">
                                {rowData?.created_at
                                  ? moment
                                      .utc(rowData?.created_at)
                                      .local()
                                      .format("DD MMM YYYY hh:mm a")
                                  : "-"}
                              </td>
                            );
                            break;
                          case "impact_type":
                            cellContent = (
                              <td key={index1 + 1} className="td-with-loader text-nowrap">
                                {renderParentImpactType(rowData?.decision)}
                              </td>
                            );
                            break;
                          case "exclusion_case":
                            cellContent = (
                              <td
                                style={{ width: "200px" }}
                                key={index1 + 1}
                                className="td-with-loader"
                              >
                                {FilterPreview({
                                  filters: JSON.parse(
                                    getCubeFiltersByActionTypeForCamelCase(
                                      rowData?.rule_config?.ruleTasks,
                                      "PAUSE_PRODUCTS"
                                    ) ?? "{}"
                                  )?.query?.filters,
                                })}
                              </td>
                            );
                            break;
                          case "inclusion_case":
                            cellContent = (
                              <td key={index1 + 1} className="td-with-loader">
                                {FilterPreview({
                                  filters: JSON.parse(
                                    getCubeFiltersByActionTypeForCamelCase(
                                      rowData?.rule_config?.ruleTasks,
                                      "ENABLE_PRODUCTS"
                                    ) ?? "{}"
                                  )?.query?.filters,
                                })}
                              </td>
                            );
                            break;
                          case "frequency":
                            cellContent = (
                              <td key={index1 + 1} className="td-with-loader">
                                <p
                                  style={{ minWidth: "130px" }}
                                  className={styles.blueBadge}
                                >
                                  {rowData?.schedule_config?.day_frequency
                                    ? "Running " +
                                      getNestedValue(rowData, column?.apiKey)
                                    : "-"}
                                </p>
                              </td>
                            );
                            break;
                          case "configuration":
                            cellContent = (
                              <td key={index1 + 1} className="td-with-loader">
                                {FilterPreview({
                                  filters: JSON.parse(
                                    productSetConfig?.cubeFilters ?? '{}'
                                  )?.query?.filters
                                })}
                                <p>Date Preset: {getDatePresetLabel(JSON.parse(
                                    productSetConfig?.cubeFilters ?? '{}'
                                  )?.query?.date_preset)}</p>
                              </td>
                            )
                            break;
                          default:
                            cellContent = (
                              <td key={index1 + 1} className="td-with-loader">
                                { (getNestedValue(rowData, column?.apiKey) || '-')}
                              </td>
                            );
                        }

                        return <>{cellContent}</>;
                      })}
                    </tr>
                    {/* Child Rows */}
                    {isExpanded &&
                      (isChildDataLoading?.includes(UNIQUE_KEY)
                        ? generateShimmerTable(
                            Math.min(childPageMeta.limit, 5),
                            dataHeads.length
                          )
                        : children.length > 0
                        ? children?.map((childData, childIndex) => (
                            <tr
                              style={{ background: "#F2F1FF" }}
                              key={`${rowData.id}-${childData.id}`}
                            >
                              {/* Render child row data */}
                              {dataHeads?.map((column, index1) => {
                                let cellContent;
                                switch (column?.id) {
                                  case "impact":
                                    cellContent = (
                                      <td
                                        key={index1 + 1}
                                        className="td-with-loader"
                                      >
                                        {renderChildImpact(childData)}
                                      </td>
                                    );
                                    break;
                                  case "ad_spend_saved": {
                                    const adSpendSaved = getChildAdSpendSaved(
                                      childData
                                    );
                                    cellContent = (
                                      <td className="text-nowrap">
                                        {adSpendSaved != null && adSpendSaved !== ""
                                          ? "₹" + Number(adSpendSaved).toFixed(2)
                                          : "-"}
                                      </td>
                                    );
                                    break;
                                  }
                                  case "only_recommendation":
                                    cellContent = (
                                      <td className="text-nowrap">
                                        {renderOnlyRecommendation(rowData?.decision)}
                                      </td>
                                    );
                                    break;
                                  case "effective_status":
                                    cellContent = (
                                        <td className="text-nowrap">
                                          {rowData?.effective_change ? (
                                            rowData?.effective_change ===
                                            "PRODUCT_ENABLED" ? (
                                             
                                               "Product Included"
                                             
                                            ) : rowData?.effective_change ===
                                              "PRODUCT_PAUSED" ? (
                                             
                                              "Product Excluded"
                                              
                                            ) : (
                                              rowData?.effective_change
                                                ?.split("_")
                                                ?.join(" ")
                                            )
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                        
                                    );
                                    break;
                                  case "activity_time":
                                    cellContent = (
                                      <td
                                        key={index1 + 1}
                                        className="td-with-loader"
                                      >
                                        {childData?.created_at
                                          ? moment
                                              .utc(childData?.created_at)
                                              .local()
                                              .format("DD MMM YYYY hh:mm a")
                                          : "-"}
                                      </td>
                                    );
                                    break;
                                  case "impact_type":
                                    cellContent = (
                                      <td
                                        key={index1 + 1}
                                        className="td-with-loader text-nowrap"
                                      >
                                        {renderChildImpactType(
                                          childData?.impact_type
                                        )}
                                      </td>
                                    );
                                    break;
                                  case "campaign_name":
                                    cellContent = (
                                      <td className="text-nowrap">
                                        {campaigns ?? "-"}
                                      </td>
                                    );
                                    break;
                                  case "adset_name":
                                    cellContent = (
                                      <td className="text-nowrap">
                                        {adgroups ?? "-"}
                                      </td>
                                    );
                                    break;
                                  case "exclusion_case":
                                    cellContent = (
                                      <td
                                        style={{ width: "200px" }}
                                        key={index1 + 1}
                                        className="td-with-loader"
                                      >
                                        {isStopLossPage
                                          ? renderChildConfiguredMetrics(
                                              childData,
                                              getChildCaseFilters(
                                                rowData,
                                                "PAUSE_PRODUCTS"
                                              )
                                            )
                                          : FilterPreview({
                                              filters: JSON.parse(
                                                getCubeFiltersByActionTypeForCamelCase(
                                                  rowData?.rule_config
                                                    ?.ruleTasks,
                                                  "PAUSE_PRODUCTS"
                                                ) ?? "{}"
                                              )?.query?.filters,
                                              isChildRow: true,
                                            })}
                                      </td>
                                    );
                                    break;
                                  case "inclusion_case":
                                    cellContent = (
                                      <td
                                        key={index1 + 1}
                                        className="td-with-loader"
                                      >
                                        {isStopLossPage
                                          ? renderChildConfiguredMetrics(
                                              childData,
                                              getChildCaseFilters(
                                                rowData,
                                                "ENABLE_PRODUCTS"
                                              )
                                            )
                                          : FilterPreview({
                                              filters: JSON.parse(
                                                getCubeFiltersByActionTypeForCamelCase(
                                                  rowData?.rule_config
                                                    ?.ruleTasks,
                                                  "ENABLE_PRODUCTS"
                                                ) ?? "{}"
                                              )?.query?.filters,
                                              isChildRow: true,
                                            })}
                                      </td>
                                    );
                                    break;
                                  case "frequency":
                                    cellContent = (
                                      <td
                                        key={index1 + 1}
                                        className="td-with-loader"
                                      >
                                        <p
                                          style={{ minWidth: "130px" }}
                                          className={styles.blueBadge}
                                        >
                                          {childData?.schedule_config
                                            ?.day_frequency
                                            ? "Running " +
                                              getNestedValue(
                                                childData,
                                                column?.apiKey
                                              )
                                            : "-"}
                                        </p>
                                      </td>
                                    );
                                    break;
                                  case "configuration":
                                      cellContent = (
                                        <td key={index1 + 1} className="td-with-loader">
                                          {FilterPreview({
                                            filters:
                                              cubeFilters?.query?.filters,
                                            isChildRow: true,
                                          })}
                                        </td>
                                      )
                                      break;
                                  default:
                                    cellContent = (
                                      <td
                                        key={index1 + 1}
                                        className="td-with-loader"
                                      >
                                        {getNestedValue(
                                          childData,
                                          column?.apiKey
                                        ) || "-"}
                                      </td>
                                    );
                                }

                                return <>{cellContent}</>;
                              })}
                            </tr>
                          ))
                        : null)}
                    {isExpanded &&
                      (children.length > 0 ||
                        parentProductCount > 0 ||
                        isChildDataLoading?.includes(UNIQUE_KEY)) && (
                        <tr style={{ background: "#F2F1FF" }}>
                          <td colSpan={dataHeads.length}>
                            <div className="d-flex justify-content-end py-2">
                              <CustomPagination
                                currentPage={childPageMeta.currentPage + 1}
                                totalPages={totalChildPages}
                                onPageChange={(pageNumber) =>
                                  handleChildPageChange(
                                    UNIQUE_KEY,
                                    rowData?.track_id,
                                    rowData?.effective_change,
                                    rowData?.rule_name,
                                    pageNumber - 1,
                                    parentProductCount
                                  )
                                }
                                lazyLoading={isChildDataLoading?.includes(
                                  UNIQUE_KEY
                                )}
                                hidePagination={totalChildPages <= 1}
                                totalItems={parentProductCount}
                                itemsPerPage={childPageMeta.limit}
                              />
                            </div>
                          </td>
                        </tr>
                      )}
                  </React.Fragment>
                );
              })}
            </tbody>
          ) : (
            <div>{/* <p>NO DATA FOUND</p> */}</div>
          )}
        </table>
      ) : (
        <div className={styles.stopLossLogsLoader}>
          {/* <p>NO DATA FOUND</p> */}
          <Spinner size="lg" shape="border" />
        </div>
      )}
    </div>
  );

  return (
    <div className="campaign-list-table-data">
      <ModalRb
        dialogClassName={"automation-filter-modal"}
        Modalheading={entityListModal.title}
        show={entityListModal.show}
        ModalMainBody={entityListModalBody}
        onHide={closeEntityListModal}
      />
      <Stack className="campaign-list-main-table">
        <TableRb
          table={tableBody}
          noDataFound={!logsList?.length && !allFetchLoaders?.mainPageLoader}
        ></TableRb>
      </Stack>
    </div>
  );
};

function StopLossLogsModal({ showLogsModal, setShowLogsModal,productSetName,pageName }) {
  return (
    <Modal
      dialogClassName={styles.popupModal}
      centered={true}
      show={showLogsModal}
      animation={true}
      scrollable={true}
      onHide={() => setShowLogsModal(false)}
      seprarator={true}
    >
      <Modal.Header className="py-2 px-3 h-6" closeButton>
        <Modal.Title>Logs</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {/* Name */}
        {pageName === "productset" && <p className="m-0">{productSetName}</p>}
        <StopLossLogsList pageName={pageName} logId={showLogsModal} />
      </Modal.Body>
    </Modal>
  );
}

export default StopLossLogsModal;